import React from 'react';
import { useIntl } from 'react-intl';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';

import { comContatoIds } from './contatos';
import { mpfImprensaSchema } from './schema';

/**
 * Formulário da barra lateral.
 *
 * Sem `withObjectBrowser` porque nenhum campo do bloco navega no site: os
 * contatos são quatro campos de texto. Ver `Destaques/Data.tsx` para o caso em
 * que o wrapper é obrigatório.
 */
const Data = (props) => {
  const { block, blocksConfig, data, onChangeBlock } = props;
  const intl = useIntl();
  const schema = mpfImprensaSchema({
    intl,
    activeObject: props.activeObject,
    setActiveObject: props.setActiveObject,
  });

  // Rede de proteção para lista vinda de fora (import de conteúdo, JSON
  // escrito à mão): sem `@id` o `ObjectListWidget` não desenha o item. Só na
  // exibição do formulário — os ids passam a ser gravados junto com a primeira
  // edição do bloco (o `dataAdapter` recebe esta cópia), sem um
  // `onChangeBlock` na montagem.
  const formData = React.useMemo(
    () =>
      data?.contatos?.length
        ? { ...data, contatos: comContatoIds(data.contatos) }
        : data,
    [data],
  );

  const dataAdapter =
    blocksConfig?.[data['@type']]?.dataAdapter ??
    (({ block: b, data: d, id, onChangeBlock: onChange, value }) =>
      onChange(b, { ...d, [id]: value }));

  return (
    <BlockDataForm
      {...props}
      schema={schema}
      title={schema.title}
      onChangeField={(id, value) =>
        dataAdapter({ block, data: formData, id, onChangeBlock, value })
      }
      onChangeBlock={onChangeBlock}
      formData={formData}
      block={block}
    />
  );
};

export default Data;
